import React, { Component } from 'react';
import Errors from '../../Libraries/Form/Errors';

const Context = React.createContext({
    i18n: {},
    busy: {},
    errors: new Errors,
})

const { Provider, Consumer } = Context;

class ContextProvider extends Component {

    render() {
        return <Provider value={{
            i18n: this.props.i18n,
            config: this.props.config,
            errors: this.props.errors || new Errors,
            busy: this.props.busy,
            fields: this.props.fields,
        }}>
            { this.props.children }
        </Provider>;
    }
}

export {
    ContextProvider as Provider,
    Consumer,
};

export default Context
